import { PossibleCompetitorCompany } from 'hooks/usePossibleCompetitorCompanies';
import { PossibleCompetitorParticipation } from 'services/actions/ai_management_possible_competitors';
import { plural } from 'services/ai_management_format';
import { StatesList } from 'services/states';

export type StatusTone = 'success' | 'danger' | 'neutral' | 'dark' | 'light';

export interface StatusBadge {
  key: string;
  tone: StatusTone;
  text: string;
}

export const PERIOD_OPTIONS = [
  { value: 1, label: 'Último ano' },
  { value: 2, label: 'Últimos 2 anos' },
  { value: 3, label: 'Últimos 3 anos' },
  { value: 5, label: 'Últimos 5 anos' },
];

export const companyBadges = (company: PossibleCompetitorCompany): StatusBadge[] => {
  const badges: StatusBadge[] = [];
  if (company.won > 0) {
    badges.push({
      key: 'won',
      tone: 'success',
      text: plural(company.won, 'licitação ganha', 'licitações ganhas'),
    });
  }
  if (company.disqualified > 0) {
    badges.push({
      key: 'disqualified',
      tone: 'danger',
      text: plural(company.disqualified, 'desclassificada', 'desclassificadas'),
    });
  }
  if (company.samePublicBody > 0) {
    badges.push({
      key: 'public-body',
      tone: 'dark',
      text: `Participou de ${plural(
        company.samePublicBody,
        'licitação',
        'licitações',
      )} desse órgão`,
    });
  }
  badges.push({
    key: 'participations',
    tone: 'light',
    text: `${plural(company.participations, 'participação', 'participações')} em licitações`,
  });
  return badges;
};

export const biddingStatus = (rows: PossibleCompetitorParticipation[]): StatusBadge => {
  if (rows.some((row) => row.adjudicado)) return { key: 'won', tone: 'success', text: 'Vencedora' };
  if (rows.some((row) => row.desclassificada)) {
    return { key: 'disqualified', tone: 'danger', text: 'Desclassificada' };
  }
  if (rows.some((row) => row.inabilitada)) {
    return { key: 'disabled', tone: 'danger', text: 'Inabilitada' };
  }
  return { key: 'classified', tone: 'neutral', text: 'Classificada' };
};

export const finalPrice = (row: PossibleCompetitorParticipation) =>
  row.valor_final ?? row.lance_final;

export const competitorDescription = (row: PossibleCompetitorParticipation) =>
  row.descricao ??
  ([row.marca, row.modelo !== row.marca ? row.modelo : null].filter(Boolean).join(' / ') ||
    row.label ||
    '—');

export const cleanObjeto = (objeto: string | null) =>
  objeto?.replace(/\*[^*]*\*/g, ' ').trim() || '—';

export const stateName = (uf: string) =>
  StatesList.find((state) => state.acronym === uf)?.name ?? uf;
